import { styled } from '@/styles/stitches.config'
import { Flex } from '../layout'

export const TableFiltersContainer = styled(Flex, {
  flexWrap: 'wrap',
  width: '100%',
})
